<template>
  <b-container fluid class="p-0">
    <banner />

    <div v-if="!isShowingSalePage">
      <b-row no-gutters>
        <b-col class="text-center p-4">
          <small class="text-lightgray text-uppercase"> Lecture Numérologique Offerte </small>

          <div class="border-top-primary-dark-dot mt-2 mb-2"></div>

          <h3 class="text-gold text-uppercase">Les Révélations De Pythagore</h3>

          <h4 class="text-white text-capitalize">
            Comment Les Nombres Révèlent Les Secrets De Votre Vie... Décodez Votre Date De Naissance
          </h4>

          <div class="border-top-primary-dark-dot mt-2 mb-2"></div>
        </b-col>
      </b-row>

      <!-- 	<ui-chatbot
			ref="chatbot"
			id="numerology-chatbot"
			:storyboard="storyboard"
			:theme="CHATBOT_THEME"
			:welcomeText="``"
			:isTextOnly="true"
			:isRemovable="false"
			@remove-message="handleRemove"
			@success="handleSuccess"
			@update:storyboardPayload="handleStoryboardUpdate"
			v-if="isStepLecture === 0"
		/> -->

      <form-introduction v-if="isStepLecture === 0" :steps="stepsLecturePart1" @success="triggerStart" />
      <interactive v-else-if="isStepLecture === 1" :steps="stepsLecturePart1" @success="isStepLecture = 2" />
      <form-register v-else-if="isStepLecture === 2" @success="triggerNumerologyPart2" :user="{ firstName, gender, lifepath }" />
      <interactive v-else-if="isStepLecture === 3" :steps="stepsLecturePart2" @ended="isShowingSalePage = true" />
    </div>

    <sale-page v-else />

    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div class="height: 150px" />

    <footer class="text-center">
      <small class="text-white">
        © 2024 Académie A.I.M.E® - Métamorphose personnelle et Spiritualité Appliquée<br />
        <a href="https://academieaime.com/legal/" target="_blank">Mentions Légales</a> -
        <a href="https://academieaime.com/confidentialite/" target="_blank">Politique De Confidentialité</a> -
        <a href="https://academieaime.com/contact/" target="_blank">Contact</a>
      </small>
    </footer>
  </b-container>
</template>

<script>
/* global fbq */
import { mapActions } from "vuex";
import { FETCH, LISTEN, RESPOND, REMOVE, REGISTER, UPDATE_AUTH } from "@/store/actions";

import { BContainer, BRow, BCol } from "bootstrap-vue";
import cuid from "cuid";

import { STORYBOARD, CHATBOT_THEME } from "@/constants/numerology";

import Banner from "@/components/Landing/Banner";
import Interactive from "@/components/Interactive/";
import FormRegister from "@/components/Interactive/Numerologie/Register/";
import FormIntroduction from "./FormIntroduction";
import SalePage from "./Sale";

import Introduction from "@/constants/numerologie/01_introduction.json";
import LifePath1 from "@/constants/numerologie/02_lifepath_1.json";
import LifePath2 from "@/constants/numerologie/02_lifepath_2.json";
import LifePath3 from "@/constants/numerologie/02_lifepath_3.json";
import LifePath4 from "@/constants/numerologie/02_lifepath_4.json";
import LifePath5 from "@/constants/numerologie/02_lifepath_5.json";
import LifePath6 from "@/constants/numerologie/02_lifepath_6.json";
import LifePath7 from "@/constants/numerologie/02_lifepath_7.json";
import LifePath8 from "@/constants/numerologie/02_lifepath_8.json";
import LifePath9 from "@/constants/numerologie/02_lifepath_9.json";
import LifePath11 from "@/constants/numerologie/02_lifepath_11.json";
import LifePath22 from "@/constants/numerologie/02_lifepath_22.json";
import Expression1 from "@/constants/numerologie/04_expression_1.json";
import Expression2 from "@/constants/numerologie/04_expression_2.json";
import Expression3 from "@/constants/numerologie/04_expression_3.json";
import Expression4 from "@/constants/numerologie/04_expression_4.json";
import Expression5 from "@/constants/numerologie/04_expression_5.json";
import Expression6 from "@/constants/numerologie/04_expression_6.json";
import Expression7 from "@/constants/numerologie/04_expression_7.json";
import Expression8 from "@/constants/numerologie/04_expression_8.json";
import Expression9 from "@/constants/numerologie/04_expression_9.json";
import Expression11 from "@/constants/numerologie/04_expression_11.json";
import Expression22 from "@/constants/numerologie/04_expression_22.json";
import Transition from "@/constants/numerologie/03_transition.json";
import Vente from "@/constants/numerologie/05_conclusion.json";
import Investment from "@/constants/numerologie/06_investment.json";

import { calculateLifepath } from "@/helpers/experiences";
import { generatePassword } from "@/helpers/utils";

const LIFEPATHS = {
  1: LifePath1,
  2: LifePath2,
  3: LifePath3,
  4: LifePath4,
  5: LifePath5,
  6: LifePath6,
  7: LifePath7,
  8: LifePath8,
  9: LifePath9,
  11: LifePath11,
  22: LifePath22,
};

const EXPRESSIONS = {
  1: Expression1,
  2: Expression2,
  3: Expression3,
  4: Expression4,
  5: Expression5,
  6: Expression6,
  7: Expression7,
  8: Expression8,
  9: Expression9,
  11: Expression11,
  22: Expression22,
};

export default {
  name: "Numerologie",
  components: {
    BRow,
    BCol,
    BContainer,
    Banner,
    Interactive,
    FormRegister,
    FormIntroduction,
    SalePage,
  },
  data: () => ({
    firstName: null,
    birthdate: null,
    lifepath: null,
    expression: null,
    gender: null,

    currentDiscussionId: cuid(),
    storyboard: [],
    localStoryboardPayload: {},

    stepsLecturePart1: [Introduction],
    stepsLecturePart2: [],

    isStepLecture: 0,
    isShowingSalePage: false,

    STORYBOARD,
    CHATBOT_THEME,
  }),
  mounted() {
    const { currentDiscussionId: discussionId } = this;
    this.storyboard = this.STORYBOARD.map((step) => {
      if (!step.id) {
        step.id = cuid();
      }
      return step;
    });
    this.listen({ discussionId });
  },
  /*   updated() {
    this.$nextTick(() => {
      const chatElement = document.getElementById("numerology-chatbot");
      console.log("updated", chatElement);
      if (chatElement) {
        chatElement.scrollTop = chatElement.scrollHeight;
      }
    });
  }, */
  methods: {
    ...mapActions("aiChat", {
      fetch: FETCH,
      remove: REMOVE,
      listen: LISTEN,
      respond: RESPOND,
    }),
    ...mapActions("auth", {
      register: REGISTER,
      updateUser: UPDATE_AUTH,
    }),
    triggerStart({ birthdate, lifepath, gender, firstName, email }) {
      this.birthdate = birthdate;
      this.lifepath = lifepath;
      this.gender = gender;
      this.firstName = firstName;
      this.email = email;

      this.triggerFacebookPixelLeadEvent();
      this.registerUser();

      this.triggerNumerologyPart1({ lifepath, gender, firstName });
    },
    async triggerFetch({ discussionId }) {
      this.isLoading = true;

      const { data } = await this.fetch({ discussionId });

      if (!data) this.hasReachedTheEnd = true;

      this.isLoading = false;

      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    triggerNumerologyPart1({ lifepath, gender, firstName }) {
      this.lifepath = lifepath;
      this.gender = gender;
      this.firstName = firstName;

      if (LIFEPATHS[lifepath]) {
        this.stepsLecturePart1.push(LIFEPATHS[lifepath]);
      }

      this.stepsLecturePart1.push(Transition);
      this.isStepLecture = 1;
    },
    triggerNumerologyPart2({ expression, firstNames, lastName }) {
      this.expression = expression;

      if (EXPRESSIONS[expression]) {
        this.stepsLecturePart2.push(EXPRESSIONS[expression]);
      }

      this.stepsLecturePart2.push(Vente, Investment);
      this.isStepLecture = 3;

      this.triggerUpdateUser({ private: { firstNames, lastName } });
    },
    async handleResponse(messages) {
      const { currentDiscussionId } = this;

      const lastMessage = messages[messages.length - 1].content;
      const birthDateRegex = /(\d{2}\/\d{2}\/\d{4})/;
      const match = lastMessage.match(birthDateRegex);

      if (match) {
        const birth = match[1];
        this.triggerCalculation(birth);
      }

      await this.respond({ discussionId: currentDiscussionId, messages });
    },
    triggerCalculation(birth) {
      const [month, day, year] = birth.split("/");
      const formattedBirth = new Date(year, month - 1, day);
      this.lifepath = calculateLifepath(formattedBirth);
    },
    handleStoryboardUpdate(payload) {
      this.localStoryboardPayload = payload;
      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatElement = document.getElementById("numerology-chatbot");
        if (chatElement) {
          chatElement.scrollTop = chatElement.scrollHeight;
        }
      });
    },
    handleSuccess() {
      this.isStepLecture = 1;
    },
    handleRemove() {
      const { replyToId: id } = this;
      this.remove({ id });
    },
    registerUser() {
      const { birthdate, firstName, email, lifepath, gender } = this;
      const password = generatePassword(8);

      this.register({ birthdate, firstName, email, lifepath, gender, password });
    },
    async triggerUpdateUser(payload) {
      console.log("payload", { ...payload });
      await this.updateUser(payload);
    },
    triggerFacebookPixelLeadEvent() {
      if (typeof fbq !== "undefined") {
        fbq("track", "Lead");
      } else {
        console.error("Facebook Pixel not initialized");
      }
    },
  },
};
</script>

<style lang="scss">
.typing-effect {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  animation: typing 3s steps(40, end), wrapText 7s forwards;
}

@keyframes typing {
  from {
    max-width: 0;
  }
  to {
    max-width: 100%;
  }
}

@keyframes wrapText {
  to {
    white-space: normal;
  }
}

.typing-effect::before {
  content: "|";
  position: absolute;
  right: 0;
  animation: blink 1s infinite;
}

@keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

ui-chatbot::-webkit-scrollbar {
  width: 5px;
}

ui-chatbot::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #4b465daa;
}

ui-chatbot::-webkit-scrollbar-thumb:hover {
  background: #4b465d;
}
</style>
